import axios, { AxiosError, AxiosResponse } from "axios";
import { LoadMoreResponse } from "../interfaces/response";

declare var pm: PmInterface;

export interface RequestLoadMoreProps {
	ajaxController: AbortController;
	formData: FormData;
}

export async function requestLoadMore(
	props: RequestLoadMoreProps,
): Promise<LoadMoreResponse> {
	try {
		const axiosResponse: AxiosResponse<LoadMoreResponse> = await axios({
			method: "post",
			url: pm.ajaxurl,
			data: props.formData,
			signal: props.ajaxController.signal,
		});

		return axiosResponse.data;
	} catch (error: unknown) {
		if (axios.isAxiosError(error)) {
			const axiosError = error as AxiosError<LoadMoreResponse>;

			if (axiosError.response) {
				return axiosError.response.data;
			}
		}

		return {
			success: false,
			errorCode: "unknown_error",
			message: "An unknown error occurred.",
		};
	}
}
